import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface ComponentNotFoundProps extends PageSectionProps {
  blok: SbBlokData;
}

export const ComponentNotFound: FunctionComponent<React.PropsWithChildren<ComponentNotFoundProps>> = ({
  blok,
  sectionClassName
}) => (
  <Section width="md" className={sectionClassName} blok={blok}>
    <PageSectionHeader>Component not found</PageSectionHeader>
    <div>Component {blok.component} is not defined. Add it to src/components/index.tsx</div>
  </Section>
);
